import { render, staticRenderFns } from "./RemoveMessage.vue?vue&type=template&id=0678a576&"
import script from "./RemoveMessage.vue?vue&type=script&lang=js&"
export * from "./RemoveMessage.vue?vue&type=script&lang=js&"
import style0 from "./RemoveMessage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports